export function imageModule(item){
  //set a variable to the crop in item.properties.image.crops with the alias "MediumVideo"
  const imageCrop = item.properties.image[0].crops.find(crop => crop.alias === "VideoMedium") 
  
  const imageModule = `
  <div class="col-span-12 mb-7">
      <div class="aspect-video relative" >          
        <div class="video-image-overlay z-10 relative aspect-video">
            <img width="848" height="477" src="${item.properties.image[0].url}??cc=${imageCrop.coordinates?`${imageCrop.coordinates.x1},${imageCrop.coordinates.y1},${imageCrop.coordinates.x2},${imageCrop.coordinates.y2}`:``}&width=${imageCrop.width}&height=${imageCrop.height}&format=webp" class="object-cover w-full lazyload" />
        </div>                          
      </div>
  </div>`
  return imageModule;
}